import { SliderThumb as Thumb } from "@opstel/radix/Slider";
import classNames from "classnames";
import React from "react";

interface SliderThumbProps {
  readonly isPointerDown: boolean;
}

type ThumbProps = React.ComponentProps<typeof Thumb>;

export function SliderThumb({ isPointerDown, ...props }: SliderThumbProps & ThumbProps) {
  return (
    <Thumb
      {...props}
      className={classNames(
        "z-20 block! h-[32px] w-[3px] rounded-[2px]",
        "bg-content-interactive-default hover:bg-content-interactive-hover",
        "focus:shadow-slider active:bg-content-interactive-pressed",
        {
          "cursor-grabbing": isPointerDown,
          "cursor-grab": !isPointerDown,
        },
      )}
    />
  );
}
